module.exports = __webpack_public_path__ + "static/paymongo_payment_geteway-3824ca0ea69b005e0182b64645ff369a.png";